import { Type } from "@angular/core";
import { Col, FilteredKeys } from "../../modules/records/models/columns/col";
import { CheckResponseOnlineComponent } from "../table-components/rating/check-response-online/check-response-online.component";

export class RatingColOnlineRep<T extends object> extends Col<
  T,
  Type<CheckResponseOnlineComponent<T>>
> {
  constructor(
    columnDef: FilteredKeys<T, CheckResponseOnlineComponent<T>["data"]>,
    header?: string,
    public datePipeFormat?: string
  ) {
    super(CheckResponseOnlineComponent, columnDef, header || columnDef);
  }
}
